var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { SimpleDialogModel } from "./SimpleDialogModel";
export class AdminAPIKeyListViewModel {
    constructor(opts) {
        this.apiKeyDialogOpen = false;
        this.apiKeyToEdit = null;
        this.deleteConfirmationModel = new SimpleDialogModel();
        this.deleteConfirmationApiKey = null;
        this.organizationAPIKeyManager = opts.container.organizationAPIKeyManager;
        this.adminUIManager = opts.container.adminUIManager;
        this.bannerUIManager = opts.container.bannerUIManager;
    }
    get apiKeys() {
        if (this.organizationAPIKeyManager.apiKeys.value === NOT_LOADED) {
            return NOT_LOADED;
        }
        return this.organizationAPIKeyManager.apiKeys.value;
    }
    get page() {
        return this.organizationAPIKeyManager.apiKeys.currentPage;
    }
    get total() {
        return this.organizationAPIKeyManager.apiKeys.total;
    }
    updatePagination(paginationParams) {
        this.organizationAPIKeyManager.setPage(paginationParams.page);
    }
    createAPIKey() {
        this.apiKeyDialogOpen = true;
    }
    editAPIKey(apiKey) {
        this.apiKeyToEdit = apiKey;
        this.apiKeyDialogOpen = true;
    }
    createOrEditAPIKeyDone() {
        this.apiKeyToEdit = null;
        this.apiKeyDialogOpen = false;
    }
    async deleteAPIKey(apiKey) {
        this.deleteConfirmationApiKey = apiKey;
        const confirmed = await this.deleteConfirmationModel.showAndWait();
        if (!confirmed)
            return;
        await this.organizationAPIKeyManager.deleteApiKey(apiKey.id);
        this.bannerUIManager.displayBanner({ text: "API key successfully deleted" });
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminAPIKeyListViewModel.prototype, "apiKeyDialogOpen", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminAPIKeyListViewModel.prototype, "apiKeyToEdit", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminAPIKeyListViewModel.prototype, "deleteConfirmationApiKey", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AdminAPIKeyListViewModel.prototype, "apiKeys", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AdminAPIKeyListViewModel.prototype, "page", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AdminAPIKeyListViewModel.prototype, "total", null);
